
import km from 'keymirror'
import _ from 'underscore'

export default _.extend({
  ACTIVITY_HOMEACTSTATUS_IS_JOINED: 6813001,
  ACTIVITY_UUG_GROUP_STATUS_IS_OK: 2,
  ACTIVITY_UUG_GROUP_STATUS_IS_FAIL: 3,
  ACTIVITY_UUG_GROUP_STATUS_IS_PENDING: 1,
  ACTIVITY_MAX_GROUP_LENGTH: 5
}, km({
  ACTIVITY_GET_HOMESTATUS_SUCCESS: null,
  ACTIVITY_GET_HOMESTATUS_ERROR: null,

  ACTIVITY_GET_HOME_FLOATBANNER_SUCCESS: null,
  ACTIVITY_GET_HOME_FLOATBANNER_ERROR: null,

  ACTIVITY_GET_UUG_ACT_LIST_SUCCESS: null,
  ACTIVITY_GET_UUG_ACT_LIST_ERROR: null,
  ACTIVITY_GET_UUG_ACT_DETAIL_SUCCESS: null,
  ACTIVITY_GET_UUG_ACT_DETAIL_ERROR: null,
  ACTIVITY_GET_UUG_ACT_GROUP_LIST_SUCCESS: null,
  ACTIVITY_GET_UUG_ACT_GROUP_LIST_ERROR: null,
  ACTIVITY_GET_UUG_ACT_GROUP_DETAIL_SUCCESS: null,
  ACTIVITY_GET_UUG_ACT_GROUP_DETAIL_ERROR: null,

  ACTIVITY_CAN_SHOW_HOMEACT: null,
}))
